import React from "react";
import { Box, Grid2, Typography } from "@mui/material";

const Quote = () => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        padding: 1,
        textAlign: "center",
        margin: 0,
        backgroundImage: `linear-gradient(rgba(47, 100, 161, 0.7), rgba(122, 121, 118, 0.6)), url("/visa.webp")`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundSize: "contain",
        backgroundAttachment: "fixed",
        minHeight: "20vh",
      }}
    >
      <Grid2 container spacing={2} justifyContent="center" alignItems="center">
        <Grid2 size={{ xs: 12 }} alignItems="center">
          <Box
            sx={{
              color: "white",
              textAlign: "center",

              display: "flex",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontSize: { xs: "1.9rem", md: "2.5rem", lg: "3rem" },
                textTransform: "uppercase",
              }}
              component="div"
            >
              Our Values
            </Typography>
          </Box>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default Quote;
